(function () {
  if (window.__surfaceHeroInitialized) return;
  window.__surfaceHeroInitialized = true;

  function hidePoster(video) {
    var posterId = video.getAttribute('data-hero-poster-id');
    if (!posterId) return;

    var poster = document.getElementById(posterId);
    if (poster) {
      poster.classList.add('hero-slide__video-poster--hidden');
    }
  }

  function getNextSection(button) {
    var section = button.closest('.shopify-section') || button.closest('section');
    return section ? section.nextElementSibling : null;
  }

  document.addEventListener('playing', function (event) {
    if (event.target.matches('[data-hero-video]')) {
      hidePoster(event.target);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hero-scroll-indicator]');
    if (!button) return;

    var nextSection = getNextSection(button);
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  });
})();
